import { BodyM, HeadingS } from 'components/Typography/Typography';
import CustomConfirmationDialog from 'components/CustomConfirmationDialog/CustomConfirmationDialog';
import { translate } from 'components/Translation';
import React from 'react';
import styles from 'assets/jss/material-dashboard-pro-react/views/numberDetails/servicesStyle';
import { makeStyles } from '@material-ui/core';
import ConditionalRender from 'components/ConditionalRender/ConditionalRender';

// @ts-ignore
const useStyles = makeStyles(styles);

interface IFailureDialogProps {
	isOpen: boolean;
	hideDialog: () => void;
	text?: string;
}

const SimpleFailureDialog = ({ hideDialog, isOpen, text }: IFailureDialogProps) => {
	const classes = useStyles();
	return (
		<CustomConfirmationDialog
			isOpen={isOpen}
			isError
			hideDialog={hideDialog}
			header={
				<BodyM>
					<ConditionalRender
						show={!!text}
						onTrue={() => <>{text}</>}
						onFalse={() => <>{translate('something.went.wrong')}</>}
					/>
				</BodyM>
			}
		>
			<div className={classes.failureDialogBody}>
				<HeadingS color="danger" disableMargin>
					{translate('try.again.button')}
				</HeadingS>
			</div>
		</CustomConfirmationDialog>
	);
};

export default SimpleFailureDialog;
